// extracted by mini-css-extract-plugin
module.exports = {"container":"Projects_container__1tq7U","projectsContainer":"Projects_projectsContainer__3N7Jj"};